import { useLocationStore } from '@/entities/location/store/location';
import { useCategoriesStore } from '@/entities/category/store/category';

export default defineNuxtPlugin({
  enforce: 'post',
  async setup() {
    const locationStore = useLocationStore();
    const categoriesStore = useCategoriesStore();

    await Promise.all([locationStore.getCities(), categoriesStore.getCategories()]);
  },
});
